// extracted by mini-css-extract-plugin
export default {"container":"SentForgotPassword_container__po5Vg","image":"SentForgotPassword_image__P0ILn","title":"SentForgotPassword_title__gvBpd","text":"SentForgotPassword_text__9D0Bw"};